export default __webpack_public_path__ + "c5642aca4c31645d1ea1efa03633f13a.svg";